import { render } from "./CommunityPostModal.vue?vue&type=template&id=77932585&scoped=true"
import script from "./CommunityPostModal.vue?vue&type=script&lang=js"
export * from "./CommunityPostModal.vue?vue&type=script&lang=js"

import "./CommunityPostModal.vue?vue&type=style&index=0&id=77932585&lang=scss&scoped=true"

import exportComponent from "/home/aloco/alocohawaii.com/moa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77932585"]])

export default __exports__